var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('base-link',{staticClass:"link-wrapper",attrs:{"to":_vm.category.link,"title":_vm.category.name}},[_c('base-svg',{staticClass:"icon",attrs:{"name":_vm.category.icon}}),_c('base-font',{staticClass:"title",attrs:{"tag":"h3","color":"primary","uppercase":""}},[_vm._v(_vm._s(_vm.category.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }